import { useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PageContext from '../sub-components/PageContext';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const SnackbarAlert = () => {

    const getBackgroundColor = (severity) => {
        switch (severity) {
          case 'success':
            return '#9ECDB5'; 
          case 'error':
            return '#E1B0A8';
          case 'info':
            return '#9FCAD6'; 
          case 'warning':
            return '#E2D79D';
          default:
            return '#E0C5C0';
        }
      };


    // get context variables from parent 
    const {
        showSnackbar, 
        setShowSnackbar, 
        snackbarMessage, 
        snackbarColor, 
    } = useContext(PageContext);

    // event handler for close snackbar click 
    const handleClose = () => {
        setShowSnackbar(showSnackbar => showSnackbar = false);
    }

    return (
      // material ui snackbar component
      <Snackbar
        open={showSnackbar}
        autoHideDuration={12000}
        onClose={handleClose}
        // anchorOrigin={{ vertical: 'top', horizontal: document.querySelector('.offcanvas-backdrop')? 'left':'center' }}
        anchorOrigin={{ vertical: 'top',horizontal:'center' }}
        sx={{marginTop:'40px'}}
      >
        <Alert
          onClose={handleClose}
          sx={{
            backgroundColor: getBackgroundColor(snackbarColor),
            width: "350px",
            borderRadius: '0 0 12px 12px',
          }}
          severity={snackbarColor}
          iconMapping={{
            success: <CheckCircleIcon fontSize="inherit" />,
            error: <ErrorIcon fontSize="inherit" />,
            info: <InfoIcon fontSize="inherit" />,
            warning: <WarningIcon fontSize="inherit" />,
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
}

export default SnackbarAlert;